(function () {
  function initAccordion(el) {
    var summary = el.querySelector('.dv-accordion__header');
    var body    = el.querySelector('.dv-accordion__body');
    if (!summary || !body) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (el.open) {
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(function () {
          body.style.transition = 'height 0.3s ease';
          body.style.height = '0';
        });
        body.addEventListener('transitionend', function close() {
          el.removeAttribute('open');
          body.style.height = '';
          body.style.transition = '';
          body.removeEventListener('transitionend', close);
        });
      } else {
        el.setAttribute('open', '');
        var target = body.scrollHeight;
        body.style.height = '0';
        body.style.transition = 'height 0.3s ease';
        requestAnimationFrame(function () {
          body.style.height = target + 'px';
        });
        body.addEventListener('transitionend', function open() {
          body.style.height = '';
          body.style.transition = '';
          body.removeEventListener('transitionend', open);
        });
      }
    });
  }

  document.querySelectorAll('.dv-accordion').forEach(initAccordion);
})();